import React, {useEffect, useRef, useState} from 'react';
import {hotelCategoryService} from "../../../../jwt/_services/hotel/hotelCategoryService";
import {getStateByPath} from "../../../../redux/selectors";
import {connect, useSelector} from "react-redux";
import {Input, Row, Spinner} from "reactstrap";
import {GenericButton} from "../../../../components/buttons/customButtons";
import {DragDropList} from "../../../../components/draggableList/DragDropList";
import {
    ADD_STATE, REMOVE_STATE, setApp,
    setFilter,
    setForm,
    setItem, setLoading,
    setTableParams, setUdn,
    setViewMode
} from "../../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import ActivitySection from "../activitySection/ActivitySection";
import {SubCategorySectionForm} from "./_form";
import {TT_EDIT} from "../../../../components/i18n/toolTips";
import TranslateButton from "../../../../components/buttons/TranslateButton";

const SubCategorySection = (props) => {
    const path = props?.path + '/subCategories';
    const parentComponentState = useSelector(state => getStateByPath(state, props?.path));
    const componentState = useSelector(state => getStateByPath(state, path));

    const {  app, udn, domainObject, userIsAdmin } = parentComponentState?.data || {};

    const {  listDomainObjects } = componentState?.data || [];
    const {  filter, loading } = componentState?.data || {};

    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedItemDescription, setSelectedItemDescription] = useState('');

    const [showFormModal, setShowFormModal] = useState(true);
    const formModalRef = useRef(null);
    const descriptionRef = useRef(null);

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect( () => {
        if( !app?.id || !udn?.id || filter)
            return

        props.setApp(path, app);
        props.setUdn(path, udn);
        props.setFilter(path , {
            fbDataBase : { id : app?.fbDataBase?.id },
            item : {
                udn : { id : udn.id },
                parent : { id: domainObject?.id },
                showInHome : false
            }
        });
    }, [ app, udn ]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, hotelCategoryService, 0, 1000, filter)
    }, [ filter ]);

    useEffect(() => {
        if (!listDomainObjects || listDomainObjects.length === 0)
            return

        // find the first item with showOrder = selectedIndex
        let _item = listDomainObjects?.sort((a, b) => a?.priority - b?.priority )[selectedIndex]

        props.setItem(path, _item);

        // find item lang with showOrder = 1
        let itemLang = _item?.langs.find(l => l?.lang?.showOrder === 1);
        if (itemLang?.longDescription) {

            setSelectedItemDescription(itemLang?.longDescription);
        }
    }, [ listDomainObjects ]);

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path);

        setShowFormModal(true);
        formModalRef.current.showModal(null, listDomainObjects?.length || 0, domainObject);
    }

    const editItem = (data) => {
        props.setForm(path, true, false, false);
        props.setItem(path, data);

        setShowFormModal(true);
        formModalRef.current.showModal(data, listDomainObjects?.length || 0, domainObject);
    }

    const onReorder = (reorderProps) => {
        // Crear una copia de listDomainObjects para evitar mutaciones directas
        let updatedListDomainObjects = [...listDomainObjects];
        let dataRequest = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            items: []
        }

        for (const reorderedItem of reorderProps.list) {
            // Validar si el ítem tiene un id (es decir, si existe en la base de datos)
            if (reorderedItem.id) {
                // Buscar el ítem en listDomainObjects
                let _domainObject = updatedListDomainObjects.find(_domainObject => _domainObject.id === reorderedItem.id);

                if (_domainObject && _domainObject.showOrder !== reorderedItem.showOrder) {
                    dataRequest.items.push({
                        id: _domainObject.id,
                        priority: reorderedItem.showOrder
                    })
                }

            }
        }

        genericIndexedActions.reorder(path, hotelCategoryService, dataRequest)
    }

    const selectCategory = (_index) => {
        // console.log(listDomainObjects[_index]?.langs[0]?.longDescription)

        setSelectedIndex(_index)

        // find item lang with showOrder = 1
        let itemLang = listDomainObjects[_index]?.langs.find(l => l?.lang?.showOrder === 1);
        if (itemLang?.longDescription) {
            setSelectedItemDescription(itemLang?.longDescription);
        } else {
            setSelectedItemDescription('');
        }

        props.setItem(path, listDomainObjects[_index]);
    }

    const adjustHeight = () => {
        if (descriptionRef.current) {
            descriptionRef.current.style.height = 'auto';
            descriptionRef.current.style.height = descriptionRef.current.scrollHeight + 'px';
        }
    }

    useEffect(() => {
        adjustHeight();
    }, [selectedItemDescription]);


    const notImplemented = (data) => {
        console.log('Not implemented yet')
        console.log(data)
    }

    const renderContent = (item, index) => {
        const lbl = listDomainObjects[index]?.title || '---'

        let checkedClass = '';

        if (index === selectedIndex) {
            checkedClass = 'xwitch-checked';
        } else if (listDomainObjects[index]?.status === true) {
            checkedClass = 'xwitch-unchecked';
        } else {
            checkedClass = 'xwitch-null';
        }

        return (
            <div className={'sub-category-item ' + checkedClass} onClick={_ => { selectCategory(index) }}>
                <label>{lbl?.toUpperCase().replace('_', ' ')}</label>
                { index === selectedIndex && <GenericButton
                    style={'table'}
                    toolTip={TT_EDIT}
                    icon={'fa-pen'}
                    permission={'edit'}
                    onClick={_ => editItem(item, index)}/>}
            </div>
        )
    }

    return (<>
        {
            loading ? <Spinner animation="border"/> : <>
                {
                    listDomainObjects?.length === 0 ?
                            <div className={'sauser-add'}>
                                <h4>{'No hay secciones'}</h4>
                                <GenericButton
                                    style={'success-secondary'}
                                    label={'Agregar sección'}
                                    toolTip={'Genera un nuevo apartado para actividades'}
                                    icon={'fa-plus'}
                                    permission={'add'}
                                    onClick={_ => createItem()}/>
                            </div> :
                            <div>
                                <Row>
                                    <GenericButton
                                        style={'success-secondary'}
                                        label={'Agregar sección'}
                                        toolTip={'Genera un nuevo apartado para actividades'}
                                        icon={'fa-plus'}
                                        permission={'add'}
                                        onClick={_ => createItem()}/>
                                </Row>
                                <Row className={'sauser-container-header'}>
                                    <DragDropList
                                        items={listDomainObjects?.sort((a, b) => {
                                            if (a.status === b.status) {
                                                return a.showOrder - b.showOrder;
                                            }
                                            return b.status - a.status; // Los que tienen status true primero
                                        })}
                                        renderContent={renderContent}
                                        onReorder={onReorder}
                                        orientationHV={'horizontal-container'} // CSS class para orientar los elementos horizontalmente
                                    />
                                    {
                                        selectedItemDescription !== null  && selectedItemDescription !== '' ? <div className="form-control-disabled-input">
                                            <Input
                                                id={'selectedCategoryDescription'}
                                                type="textarea"
                                                value={selectedItemDescription}
                                                disabled={true}
                                                rows={1}
                                                innerRef={descriptionRef}
                                                onInput={adjustHeight}
                                            />
                                        </div> : null
                                    }
                                </Row>
                                <Row>
                                    <div className={'sub-category-section'}>
                                        <ActivitySection path={path} />
                                    </div>
                                </Row>
                            </div>
                    }
                </>
        }
        {
            showFormModal && <SubCategorySectionForm
                path={path}
                app={app}
                udn={udn}
                userIsAdmin={userIsAdmin}

                ref={formModalRef}
            />
        }
    </>)
}

const mapStateToProps = state => ({})

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    setLoading,
    setApp,
    setUdn,
})
export default connect(mapStateToProps, mapActionsToProps)(SubCategorySection)